import * as React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { convertDateTimeFromUTCToLocal, Field, FieldType } from 'gossamer-unified';

interface EditableProps {
  className?: string;
  clearOnSelection?: boolean;
  field: Field;
  handleBlur?: (newValue: string) => void;
  handleChange?: (newValue: string) => void;
  placeholder?: string;
  validity?: boolean;
  value: string;
}

const FIELD_TYPE_MAP: Partial<Record<FieldType, string>> = {
  [FieldType.Date]: 'date',
  [FieldType.Datetime]: 'datetime-local',
  [FieldType.Decimal]: 'number',
  [FieldType.Integer]: 'number',
  [FieldType.Text]: 'text',
};

export const Editable: React.FC<EditableProps> = (props) => {
  const isDateTime = () => props.field.type === FieldType.Datetime;
  const isDate = () => props.field.type === FieldType.Date;
  const convertIn = (str: string) => {
    try {
      return isDateTime() ? convertDateTimeFromUTCToLocal(str) : isDate() ? str.substring(0, 10) : str;
    } catch (e) {} // swallow date/time invalid format and return empty string
    return '';
  };
  // Raw string values required by and from <input type=datetime-local> do not include timezone
  // and are hence interpreted as local in this code, which converts them to UTC strings
  const convertOut = (str: string) => (isDateTime() ? new Date(str).toISOString() : str);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (props.handleBlur) {
      props.handleBlur(convertOut(event.target.value.trim()));
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.handleChange) {
      props.handleChange(convertOut(event.target.value.trim()));
    }
  };
  const defaultValue = convertIn(props.value);
  const formControlLocal = (
    <FormControl
      className={props.className}
      defaultValue={defaultValue}
      isInvalid={props.validity === false}
      isValid={props.validity === true}
      onBlur={handleBlur}
      onChange={handleChange}
      placeholder={props.placeholder || 'Enter ' + (FIELD_TYPE_MAP[props.field.type] || 'value')}
      type={FIELD_TYPE_MAP[props.field.type] || 'text'}
    />
  );
  if (!props.field.staticPrefix && !props.field.staticSuffix) {
    return formControlLocal;
  }
  return (
    <InputGroup>
      {props.field.staticPrefix && <InputGroup.Text>{props.field.staticPrefix}</InputGroup.Text>}
      {formControlLocal}
      {props.field.staticSuffix && <InputGroup.Text>{props.field.staticSuffix}</InputGroup.Text>}
    </InputGroup>
  );
};
